import { ProgramProgress } from '@/ifaces/progress-tracker';
import { UserType } from '@/ifaces/user';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Tool } from '../tools/types';
import { fetchJson } from '../util/xhr';
import { useAuthedUserContext } from './use-authed-user';

export const useProgramProgressFeature = () => {
  const { user_type, customer } = useAuthedUserContext();
  const enabled = user_type !== UserType.Anonymous && customer.showProgressTracker;
  return { enabled };
};

export const useProgramProgressQuery = ({
  programSlug,
  screen,
}: {
  programSlug?: string;
  screen?: Tool;
}) => {
  const query = useQuery<ProgramProgress>({
    queryKey: ['progress-tracker', { programSlug }],
    queryFn: () => fetchJson(`api/program/${programSlug}/progress-tracker`),
  });

  const refetch = query.refetch;
  useEffect(() => {
    refetch();
  }, [screen, refetch]);

  return query;
};
